/** ============================================================= *
 *  ---------------------- IMPORT - START ----------------------- *
 *  ============================================================= */
import 'what-input'
import jQuery from 'jquery'
import Foundation from 'foundation-sites'
import intlTelInput from 'intl-tel-input'
import 'owl.carousel'
import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
import { setHrefs } from './functions/data-hrefs'
import { initEqualizeContent } from './functions/equalizer'
import { initTelephoneInput } from './functions/intl-tel-input'
import { initDatepickerInput } from './functions/datepicker'
import { enableNegativeMargins } from './functions/negative-margins'
import { mapStyles } from './functions/map-styles'
/** ============================================================= *
 *  ----------------------- IMPORT - END ------------------------ *
 *  ============================================================= */



/** ============================================================= *
 *  ------------ GLOBAL VARIABLES DECLARATION - START ----------- *
 *  ============================================================= */
const THEME_FOLDER = "../wp-content/themes/espino_construction_rgv_v1"
const PHONE_FIELD = ".codesm-phone-field"
const DATEPICKER_FIELD = ".codesm-datepicker-field"
const DATEPICKER_FORMAT = "mm/dd/yyyy"
const EQUALIZE_CONTENT = ".codesm-equalize-content"

Foundation.addToJquery(jQuery)
Swiper.use([Navigation, Pagination])
window.intlTelInput = intlTelInput
window.setHrefs = setHrefs
window.initEqualizeContent = initEqualizeContent
window.initTelephoneInput = initTelephoneInput
window.initDatepickerInput = initDatepickerInput
window.enableNegativeMargins = enableNegativeMargins
window.mapStyles = mapStyles
// window.enableCallrailTracking = enableCallrailTracking
/** ============================================================= *
 *  ------------- GLOBAL VARIABLES DECLARATION - END ------------ *
 *  ============================================================= */



jQuery(document).ready(function(){
	jQuery(document).foundation();
	triggerThemeFunctions();

	// ADD YOUR CODE HERE
	// 
	//

	function singlePropertyGalleryFunction() {
		// SINGLE PROPERTY GALLERY
		// reference for main items
		var singlePropertyCarousel = jQuery('#single-property-carousel');
		// reference for thumbnail items
		var singlePropertyThumbnailCarousel = jQuery('#single-property-carousel-thumbs');
		//transition time in ms
		var duration = 300;

		singlePropertyCarousel.owlCarousel({
			loop: false,
			margin: 0,
			nav: false,
			dots: false,
			autoplay: true,
			autoplayTimeout: 15000,
			autoHeight: true,
			responsive: {
				0: {
					items: 1
				},
				300: {
					items: 1
				},
				600: {
					items: 1
				},
				900: {
					items: 1
				},
				1200: {
					items: 1
				},
				1440: {
					items: 1
				}
			}
		}).on('changed.owl.carousel', function (e) {
			//On change of main item to trigger thumbnail item
			singlePropertyThumbnailCarousel.trigger('to.owl.carousel', [e.item.index, duration, true]);
			singlePropertyThumbnailCarousel.find('.current').removeClass('current');
			var index = e.item.index;
			var offset = jQuery(e.target).find('.active:first').prevAll('.cloned').length;
			singlePropertyThumbnailCarousel.find('.owl-item').eq(index - offset).addClass('current');
		});

		singlePropertyThumbnailCarousel.owlCarousel({
			loop: false,
			margin: 24,
			nav: false,
			dots: false,
			autoplay: false,
			responsive: {
				0: {
					items: 2
				},
				300: {
					items: 2
				},
				600: {
					items: 3
				},
				900: {
					items: 4
				},
				1200: {
					items: 4
				},
				1440: {
					items: 4
				}
			}
		}).on('click', '.owl-item', function () {
			// On click of thumbnail items to trigger same main item
			singlePropertyCarousel.trigger('to.owl.carousel', [jQuery(this).index(), duration, true]);
			singlePropertyThumbnailCarousel.find('.current').removeClass('current');
			jQuery(this).addClass('current');

		}).on('changed.owl.carousel', function (e) {
			// On change of thumbnail item to trigger main item
			singlePropertyCarousel.trigger('to.owl.carousel', [e.item.index, duration, true]);
		});

		singlePropertyThumbnailCarousel.find('.owl-item').first().addClass('current');

		jQuery('#singlePropertyCarouselRight').click(function () {
			singlePropertyCarousel.trigger('next.owl.carousel');
		});
		jQuery('#singlePropertyCarouselLeft').click(function () {
			singlePropertyCarousel.trigger('prev.owl.carousel');
		});
	}

	// Initialize Single Property Gallery
	if (jQuery('#single-property-carousel').length !== 0) {
		singlePropertyGalleryFunction();
	}

	// TESTIMONIALS SWIPER
	var testimonialSwiper = new Swiper('#testimonials.swiper-container', {
		slidesPerView: 1,
		spaceBetween: 20,
		
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},

		breakpoints: {
			1440: {
				slidesPerView: 1,	
			},
			1024: {
				slidesPerView: 1,	
			},
			640: {
				slidesPerView: 1,
			}
		},
		on: {
			'init': function () {
				new Foundation.Equalizer(jQuery("#testimonials.swiper-container")).applyHeight();
			},
		},
	});

});



/** ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= *
 *  ----------------- THEME FUNCTIONS - START ------------------- *
 *  ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= */
function triggerThemeFunctions()
{
	// REMOVE EMPTY P TAGS CREATED BY WP INSIDE OF ACCORDION AND ORBIT
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// ADD FLEX VIDEO TO YOUTUBE AND VIMEO EMBEDS
	jQuery(':not(.responsive-embed):not(.flex-video)>iframe[src*="youtube.com"], :not(.responsive-embed):not(.flex-video)>iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// ENABLE PSEUDO ELEMENTS FOR FONT AWESOME
	window.FontAwesomeConfig = {
		searchPseudoElements: true
	};

	// DISABLE FIRST OPTION
	jQuery('select.disable-first-option').each(function(){
		jQuery(this).find('option').first().attr('disabled', 'disabled');
	});

	// HANDLE DATA-HREF
	window.setHrefs();

	// TRIGGER EQUALIZER
	window.initEqualizeContent(EQUALIZE_CONTENT);

	// INTL-TEL-INPUT
	window.initTelephoneInput(PHONE_FIELD, THEME_FOLDER);

	// ENABLE NEGATIVE MARGINS
	window.enableNegativeMargins();

	// FOUNDATION DATEPICKER
	window.initDatepickerInput(DATEPICKER_FIELD, DATEPICKER_FORMAT);

	// // ENABLE CALLRAIL TRACKING
	// window.enableCallrailTracking();
}
/** ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= *
 *  ------------------ THEME FUNCTIONS - END -------------------- *
 *  ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= */